import React from 'react'

//Styles
import Styles from './entry-data-pemilik.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import TextLarge from 'pages/dashboard/e-reporting/forms/components/reuseables/text-large'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import ButtonIconCustom from 'pages/dashboard/e-reporting/forms/components/reuseables/button-icon-custom/ButtonIconCustom'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Assets
import { ReactComponent as ArrowDown } from 'assets/arrow-down-with-tail.svg'

import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function EntryDataPemilik() {
  const { setCurrentStep, handlePrevState } = useFormMethod();

  const handleNext = () => {
    handlePrevState()
    setCurrentStep(STEPS.namaPemilikProperti);
  }

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          Isi data pemilik properti
        </TextMedium>
      </div>

      <div className={Styles['input-wrapper']}>
        <TextLarge>
          Lengkapi data pemilik properti
        </TextLarge>
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            <ButtonIconCustom
              text={'Mulai  mengisi'}
              Icon={ArrowDown}
              onClick={handleNext}
            />
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default EntryDataPemilik